import {
  EMarketingCenterFormats,
  IMarketingCenterFormat
} from '@/models/marketingCenter/format';
import { ICanvasElement } from '@/models/marketingCenter/canvas';

class InstagramStoryFormat implements IMarketingCenterFormat {
  constructor(elements: ICanvasElement[]) {
    this.elements = elements;
  }

  key = EMarketingCenterFormats.instagramStory;
  name = 'Instagram Story';
  elements: ICanvasElement[];
  canvas = {
    width: 251,
    height: 446
  };
  asset = {
    width: 1080,
    height: 1920
  };
  share = {
    width: 59,
    height: 105,
    icon: 'instagram'
  };
}

export default InstagramStoryFormat;
